import { defineNuxtPlugin } from '#app'

// This Nuxt plugin performs the following actions:
// 1. Creates and mounts a component in the DOM to display a loading state.
// 2. Removes the loading component after the page loading is completed.

export default defineNuxtPlugin((nuxtApp) => {
  // Check if the 'document' object and its 'body' property exist.
  if (document && document.body) {
    // Create a 'div' element to display the loading component.
    const loaderHtmlComponent = document.createElement('div')
    // Insert the HTML code for the loading component, specified in the plugin options.
    loaderHtmlComponent.innerHTML = `<style>
  .splash-container {
    font-family: IranSans;
    height: 100dvh;
    transition: opacity 0.2s ease-in-out;
    z-index: 100000;
    width: 100%;
    background:
      url('./taline-bg.svg') center / cover no-repeat,
      linear-gradient(360deg, #653684 39.31%, #653684 100%);
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    margin: 0 auto;
    opacity: 1;
    animation: fadeOut 0.3s ease-in-out 6s forwards;
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  .splash-images {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    position: relative;
    margin-bottom: 200px;
  }

  .splash-image {
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto;
    width: 100%;
  }

  .splash-glow {
  }

  .progress-bar {
    width: min(100vw, 590px);
    aspect-ratio: 589 / 86;
    clip-path: path(
      'M548.636 2.07715C557.103 1.96777 563.265 1.89218 568.033 2.4375C572.745 2.97638 575.839 4.09879 578.287 6.20703C580.732 8.31248 582.305 11.2239 583.546 15.8535C584.8 20.5356 585.65 26.7109 586.812 35.1924C588.272 45.8408 589.333 53.62 589.321 59.5977C589.31 65.5223 588.238 69.3175 585.734 72.2188C583.228 75.1238 579.655 76.7373 573.861 77.6143C568.011 78.4997 560.251 78.5877 549.622 78.7021L40.1748 84.1885C30.7118 84.2904 23.8141 84.3599 18.5352 83.7129C13.3128 83.0728 9.97571 81.7608 7.45898 79.3164C7.38015 79.2398 7.30112 79.1621 7.22363 79.084C4.75231 76.5937 3.40427 73.2708 2.70801 68.0557C2.00422 62.784 2 55.8855 2 46.4219C2 37.1609 2.00386 30.4126 2.6875 25.2441C3.36373 20.1319 4.67368 16.8572 7.07617 14.3789C7.15151 14.3012 7.22797 14.2238 7.30469 14.1475C9.75174 11.7129 13.0091 10.3604 18.1123 9.61816C23.2716 8.86777 30.0197 8.77685 39.2803 8.65723L548.636 2.07715Z'
    );
    margin: 0 auto;
    background-color: #794a98;
    position: fixed;
    bottom: 90px;
    right: 0;
    left: 0;
  }

  @media screen and (max-width: 768px) {
    .progress-bar {
      width: min(100vw, 300px);
      aspect-ratio: 298 / 44;
      clip-path: path(
        'M0 23.4845C0 14.1702 0 9.51305 2.85347 6.56981C2.89585 6.5261 2.93862 6.48277 2.98178 6.43983C5.88792 3.54858 10.5447 3.48843 19.8582 3.36812L277.532 0.0395838C286.046 -0.0703942 290.303 -0.125383 293.205 2.3737C296.108 4.87278 296.692 9.13716 297.861 17.6659C299.329 28.3801 300.063 33.7372 297.079 37.1953C294.095 40.6534 288.748 40.7109 278.055 40.8261L20.3347 43.6014C10.8171 43.7039 6.05835 43.7551 3.06822 40.8507C3.02388 40.8077 2.97994 40.7642 2.9364 40.7203C0 37.7617 0 33.0026 0 23.4845Z'
      );
      margin: 0 auto;
    }
  }

  .progress-fill {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #471866;
    height: 100%;
    width: min(100vw, 590px);
    aspect-ratio: 589 / 86;
    clip-path: path(
      'M548.636 2.07715C557.103 1.96777 563.265 1.89218 568.033 2.4375C572.745 2.97638 575.839 4.09879 578.287 6.20703C580.732 8.31248 582.305 11.2239 583.546 15.8535C584.8 20.5356 585.65 26.7109 586.812 35.1924C588.272 45.8408 589.333 53.62 589.321 59.5977C589.31 65.5223 588.238 69.3175 585.734 72.2188C583.228 75.1238 579.655 76.7373 573.861 77.6143C568.011 78.4997 560.251 78.5877 549.622 78.7021L40.1748 84.1885C30.7118 84.2904 23.8141 84.3599 18.5352 83.7129C13.3128 83.0728 9.97571 81.7608 7.45898 79.3164C7.38015 79.2398 7.30112 79.1621 7.22363 79.084C4.75231 76.5937 3.40427 73.2708 2.70801 68.0557C2.00422 62.784 2 55.8855 2 46.4219C2 37.1609 2.00386 30.4126 2.6875 25.2441C3.36373 20.1319 4.67368 16.8572 7.07617 14.3789C7.15151 14.3012 7.22797 14.2238 7.30469 14.1475C9.75174 11.7129 13.0091 10.3604 18.1123 9.61816C23.2716 8.86777 30.0197 8.77685 39.2803 8.65723L548.636 2.07715Z'
    );
    margin: 0 auto;
    animation: fill 5.5s linear forwards;
  }

  @keyframes fill {
    0% {
      width: 10%;
      top: 0px;
    }

    100% {
      width: 100%;
      top: 0px;
    }
  }

  @media screen and (max-width: 768px) {
    .progress-fill {
      width: min(100vw, 300px);
      aspect-ratio: 298 / 44;
      clip-path: path(
        'M0 23.4845C0 14.1702 0 9.51305 2.85347 6.56981C2.89585 6.5261 2.93862 6.48277 2.98178 6.43983C5.88792 3.54858 10.5447 3.48843 19.8582 3.36812L277.532 0.0395838C286.046 -0.0703942 290.303 -0.125383 293.205 2.3737C296.108 4.87278 296.692 9.13716 297.861 17.6659C299.329 28.3801 300.063 33.7372 297.079 37.1953C294.095 40.6534 288.748 40.7109 278.055 40.8261L20.3347 43.6014C10.8171 43.7039 6.05835 43.7551 3.06822 40.8507C3.02388 40.8077 2.97994 40.7642 2.9364 40.7203C0 37.7617 0 33.0026 0 23.4845Z'
      );
    }
  }

  .footer-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 0;
    left: 0;
    margin: 0 auto;
    bottom: 40px;
  }

  .white-logo {
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7489%)
      hue-rotate(270deg) brightness(103%) contrast(107%);
  }
</style>

<div id="splash-container" class="splash-container">
  <div class="splash-images">
    <img src="./friends-group.png" alt="Pic" class="splash-image" />
    <img src="./glow1.png" alt="Pic" class="splash-glow" />
  </div>
  <div class="progress-bar">
    <div class="progress-fill"></div>
  </div>

  <a href="https://taline.ir/" target="_blank" class="footer-logo">
    <img src="./taline-logo.svg" alt="Icon" />
    <img src="./taline-text.svg" alt="Icon" class="white-logo" />
  </a>
</div>
`
    // Insert the loading component at the beginning of the document's body.
    document.body.insertBefore(loaderHtmlComponent, document.body.firstChild)

    function removeHTMLComponent() {
      if (loaderHtmlComponent) {
        // Remove the loading component.
        loaderHtmlComponent.remove()
      }
    }

    // Register the 'page:finish' hook to perform actions after page loading is complete.
    nuxtApp.hook('page:finish', () => {
      setTimeout(() => {
        // Remove the loading component.
        const loader = document.getElementById('splash-container')
        if (loader) {
          loader.classList.add('container--hidden')
          loader.classList.remove('fade-in')
          setTimeout(() => {
            removeHTMLComponent()
          }, 200)
        } else {
          removeHTMLComponent()
        }
      }, Number(`1500`))
    })

    // Remove element after fatal error occures
    nuxtApp.hook('app:error', () => {
      // Remove the loading component.
      removeHTMLComponent()
    })
  }
})
